// usergroup object repository

import http from '../services/http'
import auth from '../services/auth'

const BASE_ROUTE = '/settings/consumer'

export default {
  fetchSettings: function () {
    return http.get(`${BASE_ROUTE}/`, auth.getAuthHeader()).then(apiToModel)
  },
  patchSettings: function (payload) {
    payload.localized_thank_you = modelFieldTranslationsToAPI(payload.localized_thank_you)
    payload.localized_marker_request = modelFieldTranslationsToAPI(payload.localized_marker_request)
    return http.patch(`${BASE_ROUTE}/`, auth.getAuthHeader(), payload)
  }
}

function apiToModel (payload) {
  let data = {
    export_type: payload.export_type,
    export_individual_format: payload.export_individual_format,
    ftp: payload.ftp,
    film_something_now_enabled: payload.film_something_now_enabled,
    localized_thank_you: apiTranslationsToModelField(
      payload.localized_thank_you
    ),
    localized_marker_request: apiTranslationsToModelField(
      payload.localized_marker_request
    ),
    ios_app_version: payload.ios_app_version,
    video_quality: payload.video_quality,
  }
  return data
}

function apiTranslationsToModelField (field) {
  let res = {}
  field.forEach(element => {
    res[element['lang']] = element['translation']
  })
  return res
}

function modelFieldTranslationsToAPI (field) {
  return Object.entries(field).reduce((total, el) => {
    total.push({'lang': el[0], 'translation': el[1]})
    return total
  }, [])
}
